import { useEffect, useState } from "react";

/**
 * The custom-range date inputs fire onChange on every keystroke and every nudge of
 * the spinner. Each distinct value used to mean ten fresh requests; it now means
 * opening a stream and aborting it a moment later, which cancels a query
 * mid-flight on the server. Waiting for the typing to settle avoids both.
 */
export const useDebouncedValue = <T,>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};
